<template>
  <div>
    <AccordionCard :state="cards.warrantyQCellsAttachments">
      <template v-slot:header>
        {{ $t('warrantyQCellsAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('warrantyQCellsAttachments') }}</div>
        <div class="flex-column select"></div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.warrantyQCellsAttachments"
            attachmentType="warrantyQCellsAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="iswarrantyQCellsAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="warrantyQCellsAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="iswarrantyQCellsAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.acceptanceProtocolCustomerSignatureAttachments">
      <template v-slot:header>
        {{ $t('acceptanceProtocolCustomerSignatureAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('acceptanceProtocolCustomerSignatureAttachments') }}
        </div>
        <div class="flex-column select"></div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.acceptanceProtocolCustomerSignatureAttachments"
            attachmentType="acceptanceProtocolCustomerSignatureAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isacceptanceProtocolCustomerSignatureAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="acceptanceProtocolCustomerSignatureAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="
              isacceptanceProtocolCustomerSignatureAttachmentsUploadComplete = false
            "
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AccordionCard from '@/components/AccordionCard';
import AccordionCardOptionalInput from '@/components/AccordionCardOptionalInput';
import AttachmentGallery from '@/components/AttachmentGallery';
import DropzoneUpload from '@/components/DropzoneUpload';

export default {
  name: 'ExistingDamage',
  components: {
    AccordionCard,
    AttachmentGallery,
    DropzoneUpload,
    //AccordionCardOptionalInput,
  },
  props: {
    project: { type: Object },
    cards: { type: Object },
  },
  data() {
    return {
      /** track Upload states for clearing dropzone preview */
      iswarrantyQCellsAttachmentsUploadComplete: false,
      isacceptanceProtocolCustomerSignatureAttachmentsUploadComplete: false,
    };
  },
  computed: {
    ...mapGetters(['getEnumValues', 'getReportTemplateImages']),
  },

  methods: {
    ...mapActions(['uploadProjectAttachment', 'deleteProjectAttachment']),

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },

    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
    },
  },
  async mounted() {
    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.iswarrantyQCellsAttachmentsUploadComplete = true;
          this.isacceptanceProtocolCustomerSignatureAttachmentsUploadComplete = true;
        }
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>
